// Entrypoint for the about-us "A Letter from Bondi" deck (BB-299).
// Loaded by sections/about-letter.liquid only, so it stays out of the
// global custom-elements bundle.
import "./elements/about-letter/about-letter";
